import React, { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import ComponentLoader from './component-loader'
import PerosnalAccountLayout from 'layouts/personal-account/component/perosnal-account-layout'

// MAIN
const Employee = ComponentLoader(
  lazy(() => import('../layouts/employee/employee'))
)

// ACCOUNT
const Account = ComponentLoader(
  lazy(() => import('../layouts/common/account/account'))
)
const Profile = ComponentLoader(
  lazy(() => import('../layouts/common/account/profile'))
)
const UpdatePassword = ComponentLoader(
  lazy(() => import('../layouts/common/account/update-pass'))
)

const EmployeeRoutes = [
  {
    path: '',
    element: <PerosnalAccountLayout />,
    children: [
      {
        path: '',
        index: true,
        element: <Employee />,
      },
      {
        path: 'account',
        element: <Account />,
        children: [
          {
            path: '',
            index: true,
            element: <Profile />,
          },
          {
            path: 'password',
            element: <UpdatePassword />,
          },
        ],
      },

      {
        path: '*',
        element: <Navigate to={''} />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to={''} />,
  },
]

export default EmployeeRoutes
